<div class="action-row">
    @for (action of actions(); track $index) {
        <copilot-rich-block-action-button [action]="action" (activate)="activateAction.emit($event)" />
    }
</div>
